import { useMemo } from 'react';

import { keyframes, Flex, Spinner, Skeleton } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createDomName } from '../../utils/dom/identifying';
import { FULL_WIDTH_ABSOLUTE_STYLE } from '../../utils/styling/layouts';

export interface IBlockingLoadingWrapperProps extends IBaseDomElementProps {
  overlayColor?: string;
  delay?: number;
  withLoader?: boolean;
  withAnimation?: boolean;
  opacity: number;
  zIndex?: number;
}

export function BlockingLoadingWrapper({
  id,
  className = createDomName('blocking-loader'),
  overlayColor,
  delay = 0,
  opacity = 1,
  withLoader,
  withAnimation,
  zIndex = 100000,
}: IBlockingLoadingWrapperProps) {
  const easeInAnimation = useMemo(
    () => keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: ${opacity};
    }
  `,
    [opacity],
  );

  return (
    <Flex
      id={id}
      className={className}
      alignItems={'center'}
      justifyContent={'center'}
      zIndex={zIndex}
      background={overlayColor || 'gray.400'}
      opacity={opacity}
      animation={`${delay}ms ${easeInAnimation} linear`}
      sx={FULL_WIDTH_ABSOLUTE_STYLE}
    >
      {withAnimation ? (
        <Skeleton
          borderRadius={0}
          sx={{
            ...FULL_WIDTH_ABSOLUTE_STYLE,
            animationDirection: 'reverse!important',
          }}
        />
      ) : null}
      {withLoader ? <Spinner color="text-primary" /> : null}
    </Flex>
  );
}
